import { Charts } from './Charts';
import FetalDeathChartsDataProvider from './contexts/FetalDeathChartsDataContext';

const FetalDeathWrapper = () => {
    return (
        <FetalDeathChartsDataProvider>
            <Charts />
        </FetalDeathChartsDataProvider>
    );
};

export default FetalDeathWrapper;
